// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__ROTwY","col":"Table_col__3VH6C","fulfillmentStatus":"Table_fulfillmentStatus__2XVKn","emailCol":"Table_emailCol__2sR9e"};